import { fetchOfferingQueryFn } from './fetch-offering.query';
export const fetchCurrencyQueryFn = async props => {
  const {
    currencySettings
  } = await fetchOfferingQueryFn(props);
  return {
    currency: currencySettings == null ? void 0 : currencySettings.code
  };
};
//# sourceMappingURL=fetch-currency.query.js.map